<template>
  <b-form-group>
    <div class="row form-generator__items">
      <div class="col col-12 col-md-4">
        <label class="form__label">Date from:</label>
        <Datepicker
          :bootstrap-styling="true"
          :value="_toIsoStringTime(dates.date_from)"
          @input="dates.date_from = _toLocalTime($event); changeInterval()"
          format="yyyy-MM-dd"
        />
      </div>
      <div class="col col-12 col-md-4">
        <label class="form__label">Date to:</label>
        <Datepicker
          :bootstrap-styling="true"
          :value="_toIsoStringTime(dates.date_to)"
          @input="dates.date_to = _toLocalTime($event); changeInterval()"
          format="yyyy-MM-dd"
        />
      </div>
      <div class="col col-12 col-md-4">
        <label class="form__label">&nbsp;</label>
        <b-button
          type="submit"
          class="button w-100 justify-content-center"
          variant="primary"
          @click.prevent="handleAutoFillButtonClick">
          Auto Fill Contractors
        </b-button>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { mapActions } from 'vuex'

export default {
  name: 'FinancePayoutsFormAutoFill',
  components: { Datepicker },
  props: {
    payout_id: {
      type: Number,
      default: null
    },
    contractor: {
      type: Object,
      default: () => []
    },
    partner: {
      type: Object,
      default: () => []
    },
    dates: {
      type: Object,
      default: () => ({ date_from: null, date_to: null })
    },
    currency_code: {
      type: String,
      default: ''
    },
    currency_rate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      setIsModalLoading: 'finances/setIsModalLoading'
    }),
    autoFillRequest (isUserInitiated) {
      const payoutId = this.payout_id
      const partnerId = this.partner ? this.partner.id : null
      const contractorId = this.contractor ? this.contractor.id : null
      const currencyCode = this.currency_code
      const currencyRate = this.currency_rate

      if (!partnerId && !contractorId) {
        this.$snotify.info(
          'Please select Contractor or Partner first',
          'Info',
          this.$store.state.snotify
        )
        return
      }
      if (!currencyCode) {
        this.$snotify.info(
          'Please select contractor or partner bank details to init Currency code',
          'Info',
          this.$store.state.snotify
        )
        return
      }

      const dateFrom = this._toLocalTime(this.dates.date_from)
      const dateTo = this._toLocalTime(this.dates.date_to)

      if (!dateFrom || !dateTo) {
        this.$snotify.info(
          'Please select time interval: "date from" - "date to" ',
          'Info',
          this.$store.state.snotify
        )
        return
      }

      this.setIsModalLoading(true)

      this.axios.post(
        `/api/finances/payouts/auto-fill-request`,
        {
          payout_id: payoutId, contractor_id: contractorId, partner_id: partnerId, date_from: dateFrom, date_to: dateTo, currency_code: currencyCode, currency_rate: currencyRate
        },
        { headers: { Authorization: 'Bearer' + localStorage.getItem('access_token') } })
        .then(({ data }) => {
          this.$emit('auto-fill', data, isUserInitiated)
        })
        .catch((error) => {
          if (error.response) {
            this.errorNotifications(error)
          } else {
            throw error
          }
        })
        .finally(() => {
          this.setIsModalLoading(false)
        })
    },
    handleAutoFillButtonClick () {
      this.autoFillRequest(true)
    },
    changeInterval () {
      this.$emit('changeInterval', this.dates)
    }
  }
}
</script>
